<template>
    <van-sticky>
        <van-nav-bar
            :style="{ paddingTop: statusBarHeight, backgroundColor: '#FFFFFF' }"
            :title="title"
            left-arrow
            :right-text="rightText"
            @click-left="onClickLeft"
            @click-right="onClickRight"
            class="reset-nav-bar"
        >
            <template #left>
                <slot name="nav-left" />
            </template>
            <template #right>
                <slot name="nav-right" />
            </template>
        </van-nav-bar>
        <slot name="stickyBox" />
    </van-sticky>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        rightText: {
            type: String,
            default: ''
        },
        rightIcon: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isWechat: this.$publicFn.getUserAgent() === 'wechat',
            statusBarHeight: 0,
        }
    },
    created() {
        this.setCompatible();
    },
    methods: {
        setCompatible() {
            if(localStorage.getItem('type') == 'iOS') {
                this.statusBarHeight = `${localStorage.getItem("statusBarHeight")|| 0}px`;
                this.bottomSafeHeight = `${localStorage.getItem("bottomSafeHeight")|| 0}px`;
            }
        },
        onClickLeft() {
            this.$emit('onClickLeft');
        },
        onClickRight() {
            this.$emit('onClickRight');
        }
    },
}
</script>
<style lang="less" scoped>
</style>